function canvasselected() { 
         function removeElementBasedOnScreenSize() {
          const desktopElement = document.getElementById("desktop-project-grid");
          const mobileElement = document.getElementById("mobile-project-grid");
          const screenWidth = window.innerWidth;
      
          if (screenWidth >= 1025) {
              if (mobileElement) {
                  mobileElement.remove();
              }
          } else {
              if (desktopElement) {
                  desktopElement.remove();
              }
          }
      }

      removeElementBasedOnScreenSize();
      window.addEventListener("resize", removeElementBasedOnScreenSize);
}
// Function to refresh the gallery after every 5 sections
function newgallerycanvas() {
     (() => { "use strict"; var r, e = {}, o = {}; function t(r) { var a = o[r]; if (void 0 !== a) return a.exports; var n = o[r] = { exports: {} }; return e[r].call(n.exports, n, n.exports, t), n.exports } t.m = e, r = [], t.O = (e, o, a, n) => { if (!o) { var s = 1 / 0; for (i = 0; i < r.length; i++) { o = r[i][0], a = r[i][1], n = r[i][2]; for (var l = !0, u = 0; u < o.length; u++)(!1 & n || s >= n) && Object.keys(t.O).every((r => t.O[r](o[u]))) ? o.splice(u--, 1) : (l = !1, n < s && (s = n)); if (l) { r.splice(i--, 1); var f = a(); void 0 !== f && (e = f) } } return e } n = n || 0; for (var i = r.length; i > 0 && r[i - 1][2] > n; i--)r[i] = r[i - 1]; r[i] = [o, a, n] }, t.n = r => { var e = r && r.__esModule ? () => r.default : () => r; return t.d(e, { a: e }), e }, t.d = (r, e) => { for (var o in e) t.o(e, o) && !t.o(r, o) && Object.defineProperty(r, o, { enumerable: !0, get: e[o] }) }, t.o = (r, e) => Object.prototype.hasOwnProperty.call(r, e), (() => { var r = { 666: 0 }; t.O.j = e => 0 === r[e]; var e = (e, o) => { var a, n, s = o[0], l = o[1], u = o[2], f = 0; if (s.some((e => 0 !== r[e]))) { for (a in l) t.o(l, a) && (t.m[a] = l[a]); if (u) var i = u(t) } for (e && e(o); f < s.length; f++)n = s[f], t.o(r, n) && r[n] && r[n][0](), r[n] = 0; return t.O(i) }, o = self.webpackChunk_roots_bud_sage_sage = self.webpackChunk_roots_bud_sage_sage || []; o.forEach(e.bind(null, 0)), o.push = e.bind(null, o.push.bind(o)) })() })();
 
} 

function initializeGallery(){
(self.webpackChunk_roots_bud_sage_sage =
  self.webpackChunk_roots_bud_sage_sage || []).push([
    [143],
    {
      "./scripts/app.js": (e, t, s) => {
        "use strict";
        var i = s("../node_modules/@roots/sage/lib/client/dom-ready.js"),
          o = s("../node_modules/vanilla-lazyload/dist/lazyload.min.js"),
          n = s.n(o),
          r = s("../node_modules/@unseenco/taxi/src/taxi.js"),
          a = s("../node_modules/throttle-debounce/esm/index.js");
        const l = {
          currentScroll: 0,
          isFirstLoaded: !1,
          isDragging: !1,
          fade: null,
          smallScroll: 0,
          lerpAmount: 0.1,
          grid: {},
          textures: [],
          prepareTextures: (e, t) => {
            l.textures[e] = {
              toLoad: t,
              loaded: 0,
            };
          },
          detect: {
            uA: navigator.userAgent.toLowerCase(),
            get iPadIOS13() {
              return (
                "MacIntel" === navigator.platform && navigator.maxTouchPoints > 1
              );
            },
            get isMobile() {
              return (
                (/mobi|android|tablet|ipad|iphone/.test(this.uA) &&
                  window.innerWidth <= 1024) ||
                this.iPadIOS13
              );
            },
            get isMobileAndroid() {
              return /android.*mobile/.test(this.uA);
            },
            get isFirefox() {
              return this.uA.indexOf("firefox") > -1;
            },
            get isAndroid() {
              return (
                this.isMobileAndroid ||
                (!this.isMobileAndroid && /android/i.test(this.uA))
              );
            },
            get safari() {
              return this.uA.match(/version\/[\d.]+.*safari/);
            },
            get isSafari() {
              return this.safari && !this.isAndroid;
            },
          },
          lerp: (e, t, s) => e * (1 - s) + t * s,
          clamp: (e, t, s) => Math.min(Math.max(e, t), s),
          map: (e, t, s, i, o) => ((e - t) * (o - i)) / (s - t) + i,
          round: (e, t) => {
            const s = t ? Math.pow(10, t) : 100;
            return Math.round(e * s) / s;
          },
          unequal: (e, t) => 0 !== l.round(Math.abs(t - e), 4),
          closest: (e, t) => {
            const s = e.reduce((e, s) =>
              Math.abs(s - t) < Math.abs(e - t) ? s : e
            );
            return e.indexOf(s);
          },
          cancelAnimation: (e) => {
            e && (e.pause(), e.invalidate(), e.kill());
          },
        };
        var h = l,
          d = s("../node_modules/@studio-freight/lenis/dist/lenis.modern.mjs"),
          c = s("../node_modules/gsap/index.js"),
          u = s("../node_modules/gsap/CustomEase.js"),
          m = s("../node_modules/gsap/ScrollTrigger.js"),
          p = s("../node_modules/tweakpane/dist/tweakpane.js"),
          g = s("../node_modules/tiny-emitter/index.js"),
          v = s.n(g),
          y = s(
            "../node_modules/@tweakpane/plugin-essentials/dist/tweakpane-plugin-essentials.js"
          ),
          x = s("../node_modules/splitting/dist/splitting.js"),
          w = s.n(x);
        c.ZP.registerEffect({
          name: "textReveal",
          effect: (e, t) => {
            const s = c.ZP.timeline({
              defaults: {
                duration: t.duration,
                ease: t.ease,
              },
            });
            for (let t = 0; t < e[0].linesChars.length; t++) {
              const i = e[0].linesChars[t];
              s.to(
                i,
                {
                  opacity: 1,
                  stagger: 0.0125,
                  duration: 0,
                },
                0.0425 * t
              );
            }
            return s;
          },
          defaults: {
            ease: "linear",
            duration: 0.8,
          },
          extendTimeline: !0,
        }),
          c.ZP.registerEffect({
            name: "blink",
            effect: (e, t) =>
              c.ZP.to(e, {
                opacity: t.opacity,
                stagger: t.stagger,
                duration: 0,
                ease: "none",
                delay: t.delay,
              }),
            defaults: {
              stagger: 0.05,
              delay: 0,
              opacity: 1,
            },
            extendTimeline: !0,
          }),
          c.ZP.registerEffect({
            name: "showPlane",
            effect: (e, t) => {
              const s = e[0],
                i = c.ZP.timeline({
                  defaults: {
                    duration: t.duration,
                    ease: t.ease,
                    delay: 0.2,
                  },
                });
              return (
                i.set(s.material.uniforms.uAlpha, {
                  value: 1,
                }),
                i
              );
            },
            defaults: {
              ease: "expo.out",
              duration: 0.9,
            },
            extendTimeline: !0,
          }),
          c.ZP.registerEffect({
            name: "hidePlane",
            effect: (e, t) => {
              const s = e[0],
                i = c.ZP.timeline({
                  defaults: {
                    duration: t.duration,
                    ease: t.ease,
                  },
                });
              return (
                i.set(s.material.uniforms.uAlpha, {
                  value: 0,
                }),
                i
              );
            },
            defaults: {
              ease: "power1.out",
              duration: 0.3,
            },
            extendTimeline: !0,
          });
        class S {
          constructor() {
            this.getElems(),
              (this.hasTexturesToLoad = h.textures[window.location.pathname]),
              h.resources && h.resources.load(),
              "archive-realisation" !==
              h.router.currentCacheEntry.renderer.content.dataset.template &&
              h.smoothScroll &&
              h.smoothScroll.scrollTo(0, {
                immediate: !0,
                force: !0,
              });
            const e = new Date();
            this.hasTexturesToLoad
              ? h.emitter.on("textures-loaded", () => {
                let t = new Date() - e;
                (t /= 1e3),
                  t < 2.5
                    ? setTimeout(() => {
                      this.hide();
                    }, 0)
                    : this.hide();
              })
              : this.hide();
          }
          getElems() {
            (this.$cursor = document.querySelector(".cursor")),
              c.p8.set(this.$charsW, {
                y: -t / 2 + e / 4,
              }),
              c.p8.set(this.$headerLinks, {
                yPercent: 100,
                opacity: 0,
              }),
              h.detect.isMobile
                ? ((this.iconPosition = -t / 2 + e / 4),
                  (this.iconPositionX = s),
                  c.p8.set(this.$cursorIconWrapper, {
                    x: this.iconPositionX,
                    y: this.iconPosition - 150,
                    rotate: -360,
                    opacity: 0,
                  }))
                : c.p8.set(this.$cursorIconWrapper, {
                  y: "-15rem",
                  rotate: -360,
                  opacity: 0,
                }),
              c.p8.set(this.$chars, {
                opacity: 0,
              });
          }
          hide() {
            const e = c.p8.timeline();
            e
              .to(
                this.$cursorIconWrapper,
                {
                  rotate: "0_cw",
                  ease: "linear",
                  duration: 1,
                },
                0
              )
              .to(
                this.$bg,
                {
                  autoAlpha: 0,
                  ease: "linear",
                  duration: 0.6,
                },
                0.7
              )
              .call(
                () => {
                  window.dispatchEvent(new CustomEvent("loaderComplete")),
                    (h.isFirstLoaded = !0),
                    (h.textures[window.location.pathname] = null)
                },
                [],
                0.9
              )
              .to(
                this.$charsW,
                {
                  y: 0,
                  duration: 0.9,
                  stagger: {
                    each: 0.005,
                    from: "random",
                  },
                  ease: "expo.inOut",
                  onStart: () => {
                    h.cursor && (h.cursor.canMove = !0);
                  },
                },
                0
              ),
              h.detect.isMobile &&
              e.to(
                this.$cursorIconWrapper,
                {
                  opacity: 0,
                  ease: "expo.out",
                  duration: 0.5,
                },
                "<"
              ),
              e.to(
                this.$headerLinks,
                {
                  yPercent: 0,
                  opacity: 1,
                  stagger: 0.09,
                  ease: "expo.out",
                  duration: 0.9,
                },
                "<65%"
              );
          }
        }
        class T {
          constructor(e) {
            let { el: t, cb: s, mobile: i = !1 } = e;
            (this.cb = s),
              (this.mobile = i),
              (this.mouse = {
                x: 0,
                y: 0,
              }),
              (this.el =
                "string" == typeof t
                  ? document.querySelector(t)
                  : void 0 === t
                    ? document
                    : t),
              (this.run = this.run.bind(this));
          }
          on() {
            this.listener("add");
          }
          off() {
            this.listener("remove");
          }
          listener(e) {
            this.mobile && h.detect.isMobile
              ? this.el[e + "EventListener"]("touchmove", this.run)
              : this.el[e + "EventListener"]("mousemove", this.run);
          }
          run(e) {
            const t = e.changedTouches ? e.changedTouches[0].clientX : e.clientX,
              s = e.changedTouches ? e.changedTouches[0].clientY : e.clientY;
            (this.mouse.x = t), (this.mouse.y = s), this.cb(t, s, e);
          }
        }
        class k {
          constructor() {
            this.bindMethods(),
              this.getElems(),
              this.resize(),
              (this.once = !1),
              (this.moved = !1),
              (this.canMove = !1),
              (this.cursor = {
                lerpAmount: 0.09,
                delta: {
                  x: 0,
                },
                targ: {
                  x: 0,
                  y: 0,
                },
                lerp: {
                  deltaX: 0,
                  x: 0,
                  y: 0,
                },
                last: {
                  x: 0,
                },
              }),
              (this.mm = new T({
                mobile: !1,
                cb: this.move,
              })),
              this.mm.on(),
              this.setup();
          }
          bindMethods() {
            this.move = this.move.bind(this);
          }
          getElems() {
            (this.texts = {}),
              (this.$el = document.querySelector(".cursor")),
              (this.$iconWrapper = this.$el.querySelector(".cursor-icon-w")),
              (this.$icon = this.$el.querySelector(".cursor-icon")),
              (this.$texts = {
                project: this.$el.querySelector(".cursor-text--project"),
              }),
              Object.entries(this.$texts).forEach((e) => {
                let [t, s] = e;
                "project" === t
                  ? (this.texts[t] = s)
                  : ((this.texts[t] = new (w())({
                    target: s,
                    by: "chars",
                  })[0].chars),
                    c.ZP.set(this.texts[t], {
                      autoAlpha: 0,
                    }));
              });
          }
          setup() {
            const { targ: e, lerp: t } = this.cursor;
            (e.y = h.w.h / 2 - this.rect.height),
              (t.y = h.w.h / 2 - this.rect.height),
              (this.$el.style.transform = `translate(${t.x}px, ${t.y}px)`);
          }
          show(e, t) {
            (this.oldText = this.currentText),
              (this.currentText = this.texts[e]),
              (this.current = e),
              "project" === e || "play" === e
                ? (this.oldText &&
                  c.ZP.to(this.oldText, {
                    autoAlpha: 0,
                    ease: "alpha",
                    duration: 0.2,
                  }),
                  (this.showAnimation = c.ZP.to(this.currentText, {
                    autoAlpha: 1,
                    duration: 0.3,
                    ease: "alpha",
                    delay: this.oldText ? 0.2 : 0,
                    onStart: () => {
                      this.currentText &&
                        "project" === e &&
                        (this.currentText.innerHTML = t);
                    },
                  })))
                : (this.showAnimation &&
                  (this.showAnimation.pause(),
                    this.showAnimation.invalidate(),
                    this.showAnimation.kill()),
                  this.oldText &&
                  (this.hideAnimation = c.ZP.to(this.oldText, {
                    autoAlpha: 0,
                    duration: 0,
                  })),
                  (this.showAnimation = c.ZP.to(this.currentText, {
                    autoAlpha: 1,
                    duration: 0,
                    stagger: "download" === e ? 0.025 : 0.035,
                    delay: this.oldText ? 0.1 : 0,
                  })));
          }
          hide() {
            this.showAnimation &&
              (this.showAnimation.pause(),
                this.showAnimation.invalidate(),
                this.showAnimation.kill()),
              this.currentText &&
              ("project" === this.current || "play" === this.current
                ? (this.hideAnimation = c.ZP.to(this.currentText, {
                  autoAlpha: 0,
                  ease: "alpha",
                  duration: 0.2,
                }))
                : (this.hideAnimation = c.ZP.to(this.currentText, {
                  autoAlpha: 0,
                  duration: 0,
                })),
                (this.currentText = null));
          }
          move(e, t) {
            const s =
              this.documentHeight - this.rect.height - (h.w.w / 1440) * 11;
            (this.cursor.targ.x = c.ZP.utils.clamp(
              0,
              h.w.w - this.rect.width,
              e - this.rect.width / 2
            )),
              (this.cursor.targ.y = c.ZP.utils.clamp(
                0,
                s,
                t - this.rect.height / 2
              )),
              this.moved || (this.moved = !0),
              (this.cursor.delta.x = c.ZP.utils.clamp(
                -1,
                1,
                c.ZP.utils.mapRange(0, 100, 0, 1, this.cursor.last.x - e)
              )),
              (this.cursor.last.x = e);
          }
          loading() {
            this.hide(),
              (this.loadingAnimation = c.ZP.to(this.$iconWrapper, {
                rotate: 360,
                repeat: -1,
                ease: "linear",
                duration: 1.5,
              }));
          }
          scale(e) {
            c.ZP.to(this.$iconWrapper, {
              scale: e,
              ease: "expo.out",
              duration: 0.8,
            });
          }
          loaded() {
            const e = 360 * this.loadingAnimation.progress();
            this.loadingAnimation &&
              this.loadingAnimation.isActive() &&
              (this.loadingAnimation.pause(),
                this.loadingAnimation.invalidate(),
                this.loadingAnimation.kill()),
              c.ZP.fromTo(
                this.$iconWrapper,
                {
                  rotate: e,
                },
                {
                  rotate: "0_cw",
                  ease: "power1.out",
                  duration: 1.2,
                }
              );
          }
          resize() {
            (this.rect = this.$el.getBoundingClientRect()),
              (this.documentHeight = Math.max(h.w.h, document.body.offsetHeight));
          }
          scrollUpdated() {
            this.$el.style.transform = `translate(${this.cursor.targ.x}px, ${this.cursor.targ.y + window.scrollY
              }px)`;
          }
          update() {
            this.canMove &&
              this.moved &&
              (this.once ||
                ((this.once = !0),
                  c.ZP.to(this.cursor, {
                    lerpAmount: 0.5,
                    ease: "linear",
                    duration: 1.5,
                  })),
                (this.cursor.lerp.deltaX = h.lerp(
                  this.cursor.lerp.deltaX,
                  this.cursor.delta.x,
                  0.09
                )),
                (this.cursor.lerp.x = h.lerp(
                  this.cursor.lerp.x,
                  this.cursor.targ.x,
                  this.cursor.lerpAmount
                )),
                (this.cursor.lerp.y = h.lerp(
                  this.cursor.lerp.y,
                  this.cursor.targ.y,
                  this.cursor.lerpAmount
                )),
                (this.$el.style.transform = `translate(${this.cursor.lerp.x}px, ${this.cursor.lerp.y + window.scrollY
                  }px)`),
                (this.$icon.style.transform = `rotate(${1.5 * this.cursor.lerp.deltaX * -225
                  }deg)`));
          }
        }
        class E {
          constructor(e, t) {
            (this.$el = e),
              (this.destroyed = !1),
              (this.destroyLast = t),
              this.bindMethods(),
              this.getElems(),
              this.init(),
              this.events();
          }
          onEnterCompleted() { }
          bindMethods() { }
          appear() { }
          getElems() { }
          init() { }
          events() { }
          destroy() {
            this.destroyed = !0;
          }
          resize() { }
          scroll() { }
          scrollEnd() { }
          update() { }
        }
        var I = s("../node_modules/three/build/three.module.js"),
          A = s("./scripts/GL/shaders/plane/plane.vert"),
          C = s.n(A),
          M = s("./scripts/GL/shaders/plane/plane.frag"),
          z = s.n(M),
          q = s("./scripts/GL/shaders/plane/planeHome.frag"),
          V = s.n(q);
        class F {
          constructor(e) {
            let {
              dom: t,
              smallDom: s,
              videoUrl: i,
              isVideo: o,
              domNext: n,
              index: r,
              image: a,
              format: l,
              detectInView: d = !0,
              onVideoLoaded: c,
              onViewportIntersect: u,
              isHome: m,
            } = e;
            (this.dom = t),
              (this.smallDom = s),
              (this.videoUrl = i),
              (this.isVideo = o),
              (this.index = r),
              (this.format = l),
              (this.detectInView = d),
              (this.onVideoLoaded = c),
              (this.onViewportIntersect = u),
              (this.isHome = m),
              (this.domNext = n),
              (this.image = {
                url: a ? a.url : this.dom.dataset.url,
                width: a ? a.width : this.dom.dataset.width,
                height: a ? a.height : this.dom.dataset.height,
              }),
              this.dom.dataset.urlLarge &&
              (this.image.large = {
                url: this.dom.dataset.urlLarge,
              }),
              (this.disableScrollTrigger = !1),
              (this.textureLoaded = !1),
              (this.videoLoaded = !1),
              (this.updated = !1),
              (this.location = window.location.pathname),
              (this.gl = h.GL),
              this.gl.cache[this.location] || (this.gl.cache[this.location] = []),
              (this.gl.cache[this.location][this.index] =
                this.gl.cache[this.location][this.index] || {}),
              (this.currentCache = this.gl.cache[this.location][this.index]),
              this.gl.planes.push(this);
            const p = new URLSearchParams(window.location.search).get("category");
            this.currentCache.mesh && !p
              ? ((this.mesh = this.currentCache.mesh),
                (this.material = this.currentCache.material),
                (this.geometry = this.currentCache.geometry),
                (this.texture = this.currentCache.texture),
                (this.textureLoaded = this.currentCache.textureLoaded),
                (this.largeTextureLoaded = this.currentCache.largeTextureLoaded),
                (this.largeTexture = this.currentCache.largeTexture),
                (this.videoLoaded = this.currentCache.videoLoaded),
                (this.material.uniforms.uAlpha.value = 1),
                (this.video = this.currentCache.video),
                this.video && (this.video.currentTime = 0),
                this.gl.scene.add(this.mesh))
              : this.createMesh(),
              this.setData(),
              this.detectInView && this.checkInView();
          }
          createMesh() {
            this.isHome
              ? (this.uniforms = {
                uTexture: {
                  value: "",
                },
                uVideoTexture: {
                  value: "",
                },
                uOpacity: {
                  value: 0,
                },
                uAlpha: {
                  value: 1,
                },
                uTime: {
                  value: 0,
                },
                uMeshSize: {
                  value: new I.FM8(0, 0),
                },
                uVideoSize: {
                  value: new I.FM8(1920, 1080),
                },
                uImageSize: {
                  value: new I.FM8(this.image.width, this.image.height),
                },
              })
              : (this.uniforms = {
                uActive: {
                  value: 1,
                },
                uAlpha: {
                  value: 1,
                },
                uProgress: {
                  value: 0,
                },
                uMeshSize: {
                  value: new I.FM8(0, 0),
                },
                uImageSize: {
                  value: new I.FM8(this.image.width, this.image.height),
                },
                uVideoSize: {
                  value: new I.FM8(1920, 1080),
                },
                uVideoFormat: {
                  value: "contain" === this.format ? 0 : 1,
                },
                uTexture: {
                  value: "",
                },
                uVideoTexture: {
                  value: "",
                },
                uFade: {
                  value: 0,
                },
                uScale: {
                  value: 1,
                },
                uParallaxX: {
                  value: 0,
                },
                uParallaxY: {
                  value: 0,
                },
                uParallaxAmount: {
                  value: 1,
                },
                uTranslateY: {
                  value: 0,
                },
              }),
              (this.material = new I.jyz({
                vertexShader: C(),
                fragmentShader: this.isHome ? V() : z(),
                transparent: !0,
                uniforms: this.uniforms,
              })),
              (this.geometry = new I._12(1, 1, 1, 1)),
              (this.mesh = new I.Kj0(this.geometry, this.material)),
              (this.currentCache.mesh = this.mesh),
              (this.currentCache.material = this.material),
              (this.currentCache.geometry = this.geometry),
              this.gl.scene.add(this.mesh);
          }
          load() {
            let e =
              arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
            return new Promise((t) => {
              if (e) {
                if (this.image.large) if (this.largeTextureLoaded) t();
              } else if (this.textureLoaded) this.setLoaded(), t();
              else {
                const e = this.image.url;
                e
                  ? this.gl.textureLoader.load(
                    e,
                    (e) => {
                      (e.minFilter = I.wem),
                        (e.magFilter = I.wem),
                        (e.wrapS = I.rpg),
                        (e.wrapT = I.rpg),
                        (e.generateMipmaps = !1),
                        (this.texture = e),
                        (this.material.uniforms.uTexture.value = e),
                        (this.textureLoaded = !0),
                        (this.currentCache.texture = this.texture),
                        (this.currentCache.textureLoaded = this.textureLoaded),
                        this.setLoaded(),
                        t();
                    },
                    () => { },
                    (e) => {
                    //  console.log(e);
                    }
                  )
                  : ((this.texture = null),
                    (this.material.uniforms.uTexture.value = null),
                    (this.textureLoaded = !0),
                    (this.currentCache.texture = this.texture),
                    (this.currentCache.textureLoaded = this.textureLoaded),
                    this.setLoaded(),
                    t());
              }
            });
          }
          setLoaded() {
            h.textures[window.location.pathname] &&
              h.textures[window.location.pathname].loaded++,
              h.textures[window.location.pathname] &&
              h.textures[window.location.pathname].loaded ===
              h.textures[window.location.pathname].toLoad &&
              setTimeout(() => {
                h.emitter.emit("textures-loaded");
              }, 0);
          }
          getBounds(e) {
            const t =
              arguments.length > 1 && void 0 !== arguments[1] && arguments[1]
                ? h.smallScroll
                : window.scrollY,
              s = e.getBoundingClientRect(),
              i = s.top + window.scrollY - h.w.h;
            return {
              dom: s,
              gl: {
                top: i,
                bottom: Math.min(i, 0) + s.height + h.w.h + Math.max(i, 0),
                x: s.left - h.w.w / 2 + s.width / 2,
                y: -s.top + h.w.h / 2 - s.height / 2 - t,
                w: s.width,
                h: s.height,
              },
            };
          }
          setBounds() {
            const e = {
              large: this.getBounds(this.dom),
              small: this.smallDom && this.getBounds(this.smallDom, !0),
            };
            return (this.bounds = e), e;
          }
          setData() {
            const e = this.setBounds();
            return (
              this.isHome && this.video
                ? (this.mesh.material.uniforms.uImageSize.value = new I.FM8(
                  this.video.videoWidth,
                  this.video.videoHeight
                ))
                : (this.mesh.material.uniforms.uImageSize.value = new I.FM8(
                  this.image.width,
                  this.image.height
                )),
              (this.mesh.material.uniforms.uMeshSize.value = new I.FM8(
                e.large.dom.width,
                e.large.dom.height
              )),
              this.mesh.position.set(e.large.gl.x, e.large.gl.y, 0),
              this.mesh.scale.set(e.large.dom.width, e.large.dom.height, 1),
              e
            );
          }
          updateProps(e) {
            let { dom: t, smallDom: s, index: i, detectInView: o = !0 } = e;
            (this.updated = !0),
              t && (this.dom = t),
              s && (this.smallDom = s),
              (this.index = i),
              this.dom.dataset.urlLarge &&
              (this.image.large = {
                url: this.dom.dataset.urlLarge,
              }),
              this.setBounds(),
              o && this.checkInView();
          }
          checkInView() {
            if (
              (this.sT && this.sT.kill(), "next" === this.index && this.domNext)
            ) {
              const e = c.ZP.fromTo(
                this.mesh.material.uniforms.uTranslateY,
                {
                  value: 0.05,
                },
                {
                  value: 0,
                  ease: "linear",
                }
              );
              this.parallaxST = h.scrollTrigger.create({
                trigger: this.domNext,
                scrub: !0,
                start: "top bottom",
                end: "bottom bottom",
                animation: e,
              });
            }
            (this.sT = h.scrollTrigger.create({
              trigger: this.dom,
              onEnter: () => {
                (this.inView = !0),
                  !this.disableScrollTrigger && (this.mesh.visible = !0),
                  this.onViewportIntersect && this.onViewportIntersect(!0);
              },
              onEnterBack: () => {
                (this.inView = !0),
                  !this.disableScrollTrigger && (this.mesh.visible = !0),
                  this.onViewportIntersect && this.onViewportIntersect(!0);
              },
              onLeave: () => {
                (this.inView = !1),
                  !this.disableScrollTrigger && (this.mesh.visible = !1),
                  this.onViewportIntersect && this.onViewportIntersect(!1);
              },
              onLeaveBack: () => {
                (this.inView = !1),
                  !this.disableScrollTrigger && (this.mesh.visible = !1),
                  this.onViewportIntersect && this.onViewportIntersect(!1);
              },
            })),
              (this.mesh.visible = this.sT.isActive || !1);
          }
          remove() {
            let e =
              arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
            this.mesh.visible && !e
              ? c.ZP.to(this.mesh.material.uniforms.uAlpha, {
                value: 0,
                ease: "power2.out",
                duration: 0.4,
                onComplete: () => {
                  this.dispose();
                },
              })
              : this.dispose();
          }
          dispose() {
            this.mesh.material.uniforms.uFade &&
              c.ZP.set(this.mesh.material.uniforms.uFade, {
                value: 0,
              }),
              this.sT && this.sT.kill(),
              this.material.uniforms.uTexture.value &&
              this.material.uniforms.uTexture.value.dispose(),
              this.material.dispose(),
              this.geometry.dispose(),
              this.gl.scene.remove(this.mesh);
          }
          resize() {
            this.setData();
          }
        }
        // class Z {
        //   constructor(e) {
        //     let {
        //       filters: t,
        //       items: s,
        //       filtersWrapper: i,
        //       itemsWrapper: o,
        //       onFilter: n,
        //     } = e;
        //     (this.$filters = t),
        //       (this.$filtersWrapper = i),
        //       (this.$items = s),
        //       (this.$itemsWrapper = o),
        //       (this.onFilter = n),
        //       this.bindMethods(),
        //       this.events();
        //   }
        //   bindMethods() {
        //     this.onKey = this.onKey.bind(this);
        //   }
        //   events() {
        //     !h.detect.isMobile &&
        //       document.body.addEventListener("keydown", this.onKey);
        //     for (let e = 0; e < this.$filters.length; e++)
        //       this.$filters[e].addEventListener(
        //         "click",
        //         this.onFilterClick.bind(this, e, this.$filters[e].dataset.filter)
        //       );
        //   }
        //   onFilterClick(e, t) {
        //     if (this.currentFilterIndex === e) return void this.reset();
        //     const s = [];
        //     (this.currentFilterIndex = e),
        //       this.$itemsWrapper && this.$itemsWrapper.classList.add("a"),
        //       this.$filtersWrapper && this.$filtersWrapper.classList.add("a");
        //     for (let t = 0; t < this.$filters.length; t++)
        //       this.$filters[t].classList.toggle("a", t === e);
        //     if (this.$items)
        //       for (let e = 0; e < this.$items.length; e++) {
        //         const i = this.$items[e].dataset.filter.split(",");
        //         i.includes(t) && s.push(e),
        //           this.$items[e].classList.toggle("a", i.includes(t));
        //       }
        //     this.onFilter && this.onFilter(e, t, s);
        //   }
        //   reset() {
        //     if (null !== this.currentFilterIndex) {
        //       (this.currentFilterIndex = null),
        //         this.$itemsWrapper && this.$itemsWrapper.classList.remove("a"),
        //         this.$filtersWrapper &&
        //         this.$filtersWrapper.classList.remove("a");
        //       for (let e = 0; e < this.$filters.length; e++)
        //         this.$filters[e].classList.remove("a");
        //       for (let e = 0; e < this.$items.length; e++)
        //         this.$items[e].classList.remove("a");
        //       this.onFilter && this.onFilter(-1, -1, []);
        //     }
        //   }
        //   onKey(e) {
        //     "Escape" === e.key && this.reset();
        //   }
        // }
        class Z {
  constructor(e) {
    let {
      filters: t,
      items: s,
      filtersWrapper: i,
      itemsWrapper: o,
      onFilter: n,
    } = e;
    this.$filters = t;
    this.$filtersWrapper = i;
    this.$items = s;
    this.$itemsWrapper = o;
    this.onFilter = n;
    this.bindMethods();
    this.events();
  }

  bindMethods() {
    this.onKey = this.onKey.bind(this);
  }

  events() {
    !h.detect.isMobile &&
      document.body.addEventListener("keydown", this.onKey);
    for (let e = 0; e < this.$filters.length; e++) {
      const filterElement = this.$filters[e];
      if (filterElement && filterElement.dataset) {
        filterElement.addEventListener(
          "click",
          this.onFilterClick.bind(this, e, filterElement.dataset.filter)
        );
      }
    }
  }

  onFilterClick(e, t) {
    if (this.currentFilterIndex === e) return void this.reset();
    const s = [];
    this.currentFilterIndex = e;
    this.$itemsWrapper && this.$itemsWrapper.classList.add("a");
    this.$filtersWrapper && this.$filtersWrapper.classList.add("a");
    for (let t = 0; t < this.$filters.length; t++) {
      this.$filters[t].classList.toggle("a", t === e);
    }
    if (this.$items) {
      for (let e = 0; e < this.$items.length; e++) {
        const itemElement = this.$items[e];
        if (itemElement && itemElement.dataset) {
          const i = itemElement.dataset.filter.split(",");
          i.includes(t) && s.push(e);
          itemElement.classList.toggle("a", i.includes(t));
        }
      }
    }
    this.onFilter && this.onFilter(e, t, s);
  }

  reset() {
    if (null !== this.currentFilterIndex) {
      this.currentFilterIndex = null;
      this.$itemsWrapper && this.$itemsWrapper.classList.remove("a");
      this.$filtersWrapper && this.$filtersWrapper.classList.remove("a");
      for (let e = 0; e < this.$filters.length; e++) {
        this.$filters[e].classList.remove("a");
      }
      for (let e = 0; e < this.$items.length; e++) {
        this.$items[e].classList.remove("a");
      }
      this.onFilter && this.onFilter(-1, -1, []);
    }
  }

  onKey(e) {
    "Escape" === e.key && this.reset();
  }
}

        var O = s("./scripts/GL/shaders/about-plane/about-plane.vert"),
          B = s.n(O),
          G = s("./scripts/GL/shaders/about-plane/about-plane.frag"),
          _ = s.n(G),
          H = s("./scripts/GL/shaders/object/object.vert"),
          U = s.n(H),
          Y = s("./scripts/GL/shaders/object/object.frag"),
          N = s.n(Y);
        const J = [
          {
            name: "artist",
            Class: class extends E {
              init() {
                (this.destroyLast = !0),
                  (this.isDown = !1),
                  (this.firstDrag = !1),
                  (this.isDragging = !1),
                  (this.canDrag = !0),
                  (this.drag = {
                    dragging: !1,
                    start: {
                      x: 0,
                      y: 0,
                    },
                    end: {
                      x: 0,
                      y: 0,
                    },
                    min: {
                      x: 0,
                      y: 0,
                    },
                    max: {
                      x: 0,
                      y: 0,
                    },
                    normalize: {
                      x: 0,
                      y: 0,
                      lerp: {
                        x: 0,
                        y: 0,
                      },
                    },
                    x: 0,
                    y: 0,
                  }),
                  (this.wheel = {
                    started: !1,
                    x: 0,
                    y: 0,
                  }),
                  (this.wheelDebounced = (0, a.D)(250, this.up)),
                  (this.$titleW.style.display = "none"),
                  setTimeout(() => {
                    this.$titleW.style.display = "flex";
                  }, 0),
                  (this.mm = new T({
                    cb: this.move,
                  })),
                  (this.filters = new Z({
                    filters: this.$filters,
                    filtersWrapper: this.$filtersWrapper,
                    items: this.$gridEls,
                    onFilter: this.onFilter,
                  })),
                  this.$popup &&
                  ((this.popup = new j({
                    el: this.$popup,
                    button: this.$biographyLink,
                    open: this.openPopup,
                    close: this.closePopup,
                  })),
                    c.ZP.set(this.$popupWrapper, {
                      yPercent: -100,
                    }),
                    c.ZP.set(this.$popupInner, {
                      yPercent: 100,
                    })),
                  this.setBounds(),
                  document.body.classList.add("prevent-scroll-overflow");
              }
              bindMethods() {
                (this.move = this.move.bind(this)),
                  (this.down = this.down.bind(this)),
                  (this.up = this.up.bind(this)),
                  (this.onWheel = this.onWheel.bind(this)),
                  (this.onFilter = this.onFilter.bind(this));
              }
              getElems() {
                (this.els = []),
                  (this.$gridEls = this.$el.querySelectorAll(".grid-el-w")),
                  (this.$title = this.$el.querySelector(".artist-title")),
                  (this.$titleW = this.$el.querySelector(".artist-title-w")),
                  (this.$linksWrapper = this.$el.querySelector(".artist-links")),
                  (this.$indexLink = this.$el.querySelector(".artist-index")),
                  (this.$biographyLink =
                    this.$el.querySelector(".artist-biography")),
                  (this.$links = this.$el.querySelectorAll(".artist-link")),
                  (this.$backButton = this.$el.querySelector(".back-button")),
                  (this.$dragdropText = this.$el.querySelector(".artist-drag")),
                  (this.$filters = this.$el.querySelectorAll(".filter-project")),
                  (this.$filtersWrapper =
                    this.$el.querySelector(".filters-project"));
                const e =
                  "artist" === h.fromTransition
                    ? this.$gridEls.length - 4
                    : this.$gridEls.length;
                e > 0 && h.prepareTextures(window.location.pathname, e);
                for (let e = 0; e < this.$gridEls.length; e++) {
                  let t;
                  const s = [],
                    i = this.$gridEls[e].querySelector(".grid-plane"),
                    o = h.grid.currentPlanes.find((t) => t.index === e),
                    n = i.dataset.preview && i.dataset.preview.split(",");
                  for (let e = 0; e < n.length; e++)
                    s.push({
                      url: n[e],
                      loaded: !1,
                    });
                  o
                    ? ((t = o.plane),
                      t.updateProps({
                        dom: i,
                        index: e,
                        detectInView: !1,
                      }))
                    : ((t = new F({
                      dom: i,
                      index: e,
                      detectInView: !1,
                    })),
                      (t.mesh.material.uniforms.uAlpha.value = 0),
                      (t.mesh.material.uniforms.uScale.value = 1),
                      t.load()),
                    this.els.push({
                      dom: this.$gridEls[e],
                      bounds: h.grid.els[e].bounds,
                      previews: s,
                      currentPreviewIndex: 0,
                      loadedPreviews: [],
                      lerp: 0.09,
                      plane: t,
                      animation: {
                        alpha: null,
                        z: null,
                      },
                      out: !1,
                      animations: {},
                      targ: {
                        x: 0,
                        y: 0,
                        parallaxAmount: 1,
                        gl: {
                          x: t.bounds.large.gl.x,
                          y: t.bounds.large.gl.y,
                        },
                      },
                      curr: {
                        x: 0,
                        y: 0,
                        parallaxAmount: 1,
                        gl: {
                          x: t.bounds.large.gl.x,
                          y: t.bounds.large.gl.y,
                        },
                      },
                    });
                }
                h.grid.currentPlanes = [];
              }
              events() {
                window.addEventListener("mousedown", this.down),
                  window.addEventListener("mouseup", this.up),
                  document.body.addEventListener("keydown", this.onKey),
                  window.addEventListener("wheel", this.onWheel),
                  window.addEventListener("wheel", this.wheelDebounced);
                for (let e = 0; e < this.els.length; e++) {
                  const { dom: t } = this.els[e];
                  t.addEventListener(
                    "mouseenter",
                    this.onMouseEnter.bind(this, e)
                  ),
                    t.addEventListener(
                      "mouseleave",
                      this.onMouseLeave.bind(this, e)
                    ),
                    t.addEventListener("click", this.onClick.bind(this, e));
                }
              }
              destroy() {
                (this.isNavigating = !0),
                  document.body.classList.remove("prevent-scroll-overflow"),
                  (document.documentElement.style.cursor = "none"),
                  (h.grid.cache[window.location.pathname] = {
                    x: this.drag.x,
                    y: this.drag.y,
                  }),
                  h.cursor.hide(),
                  h.cursor.scale(1),
                  this.mm.off(),
                  document.body.removeEventListener("keydown", this.onKey),
                  window.removeEventListener("mousedown", this.down),
                  window.removeEventListener("mouseup", this.up),
                  window.removeEventListener("wheel", this.onWheel),
                  window.removeEventListener("wheel", this.wheelDebounced);
                for (let e = 0; e < this.els.length; e++) {
                  const { dom: t, plane: s, loadedPreviews: i } = this.els[e];
                  t.removeEventListener(
                    "mouseenter",
                    this.onMouseEnter.bind(this, e)
                  ),
                    t.removeEventListener(
                      "mouseleave",
                      this.onMouseLeave.bind(this, e)
                    ),
                    t.removeEventListener("click", this.onClick.bind(this, e)),
                    this.currentIndex !== e &&
                    (s.remove(!0),
                      i.length > 0 &&
                      (s.mesh.material.uniforms.uTexture.value = i[0]));
                }
              }
              onEnterCompleted() {
                this.mm.on();
              }
              appear() {
                h.cursor.show("drag"),
                  h.cursor.scale(1.5),
                  (document.documentElement.style.cursor = "grab"),
                  setTimeout(() => {
                    this.appeared = !0;
                  }, 0);
                for (let e = 0; e < this.els.length; e++) {
                  const { plane: t, animation: s } = this.els[e];
                  if (((t.mesh.visible = !0), !t.updated)) {
                    const i = c.ZP.utils.random(0, 0.15);
                    (s.z = c.ZP.fromTo(
                      t.mesh.position,
                      {
                        z: -150,
                      },
                      {
                        z: 0,
                        ease: "expo.out",
                        delay: i,
                        duration: 1.2,
                      }
                    )),
                      this.animateAlpha(e, 1, 1.2, i, !1);
                  }
                }
                h.fromTransition = !1;
              }
              onFilter(e, t) {
                this.isFiltering = -1 !== e;
                for (let e = 0; e < this.els.length; e++) {
                  const { dom: s } = this.els[e],
                    i = s.dataset.filter.split(",");
                  s.children[0].classList.toggle(
                    "pointer-events-auto",
                    i.includes(t) || -1 === t
                  ),
                    this.animateAlpha(
                      e,
                      i.includes(t) || -1 === t ? 1 : 0.1,
                      0.5
                    );
                }
              }
              onMouseEnter(e) {
                if (
                  h.navigating ||
                  this.isNavigating ||
                  this.drag.dragging ||
                  !this.appeared
                )
                  return;
                let t = 0;
                const {
                  previews: s,
                  loadedPreviews: i,
                  plane: o,
                  animations: n,
                } = this.els[e];
                let { currentPreviewIndex: r } = this.els[e];
                if (
                  (h.cursor.show("project", this.els[e].dom.dataset.title),
                    0 === s.length)
                )
                  return (
                    h.cancelAnimation(n.leave),
                    void (n.enter = c.ZP.to(o.mesh.material.uniforms.uScale, {
                      //value: 0.93,
                      duration: 0.6,
                      ease: "power3.out",
                    }))
                  );
                0 === i.length
                  ? i.push(o.texture)
                  : i.length >= 2 &&
                  ((t = 1 === r ? 0 : 1),
                    (r = t),
                    (this.els[e].currentPreviewIndex = t),
                    (o.mesh.material.uniforms.uTexture.value = i[t]),
                    (o.mesh.material.uniforms.uImageSize.value = new I.FM8(
                      i[t].source.data.naturalWidth,
                      i[t].source.data.naturalHeight
                    )));
                for (let e = 0; e < s.length; e++) {
                  const { url: n, loaded: a, loading: l } = s[e];
                  (a && l) ||
                    ((s[e].loading = !0),
                      h.GL.textureLoader.load(n, (n) => {
                        (s[e].loaded = !0),
                          1 === i.length &&
                          ((t = 1),
                            (r = 1),
                            (o.mesh.material.uniforms.uTexture.value = n),
                            (o.mesh.material.uniforms.uImageSize.value = new I.FM8(
                              n.source.data.naturalWidth,
                              n.source.data.naturalHeight
                            ))),
                          i.push(n);
                      }));
                }
                this.mouseEnterInterval = setInterval(() => {
                  if (r + 1 <= i.length) {
                    t++,
                      (r = c.ZP.utils.wrap(0, i.length, t)),
                      (this.els[e].currentPreviewIndex = r);
                    const s = i[r];
                    (o.mesh.material.uniforms.uTexture.value = s),
                      (o.mesh.material.uniforms.uImageSize.value = new I.FM8(
                        s.source.data.naturalWidth,
                        s.source.data.naturalHeight
                      ));
                  }
                }, 250);
              }
              onMouseLeave(e) {
                if (h.navigating || this.isNavigating || !this.appeared) return;
                const { previews: t, plane: s, animations: i } = this.els[e];
                if ((h.cursor.hide(), 0 === t.length))
                  return (
                    h.cancelAnimation(i.enter),
                    void (i.leave = c.ZP.to(s.mesh.material.uniforms.uScale, {
                      value: 1,
                      duration: 0.6,
                      ease: "power3.out",
                    }))
                  );
                clearInterval(this.mouseEnterInterval);
              }
              onDrag() {
                document.documentElement.style.cursor = "grabbing";
                for (let e = 0; e < this.els.length; e++) {
                  const { plane: t, animation: s, targ: i } = this.els[e];
                  s.z && (s.z.pause(), s.z.invalidate(), s.z.kill());
                  const o = c.ZP.utils.random(-70, 0);
                  (i.parallaxAmount = c.ZP.utils.mapRange(-70, 0, 0.1, 1, o)),
                    (s.z = c.ZP.to(t.mesh.position, {
                      z: o,
                      ease: "expo.out",
                      duration: 1.8,
                    }));
                }
              }
              move(e, t) {
                if (
                  !this.isWheeling &&
                  this.isDown &&
                  (this.canDrag || this.forceMove)
                ) {
                  (this.drag.dragging =
                    Math.abs(t - this.drag.start.y) +
                    Math.abs(e - this.drag.start.x) >=
                    4),
                    this.drag.dragging &&
                    !this.firstDrag &&
                    ((this.firstDrag = !0),
                      "drag" === h.cursor.current && h.cursor.hide()),
                    !this.drag.dragging ||
                    this.isDragging ||
                    this.isFiltering ||
                    ((this.isDragging = !0), this.onDrag()),
                    (this.drag.x = c.ZP.utils.clamp(
                      this.drag.min.x,
                      this.drag.max.x,
                      this.drag.end.x + e - this.drag.start.x
                    )),
                    (this.drag.y = c.ZP.utils.clamp(
                      this.drag.min.y,
                      this.drag.max.y,
                      this.drag.end.y + t - this.drag.start.y
                    )),
                    (this.wheel.x = this.drag.x),
                    (this.wheel.y = this.drag.y),
                    (this.drag.normalize.x = c.ZP.utils.mapRange(
                      this.drag.min.x,
                      this.drag.max.x,
                      -1,
                      1,
                      this.drag.x
                    )),
                    (this.drag.normalize.y = c.ZP.utils.mapRange(
                      this.drag.min.y,
                      this.drag.max.y,
                      -1,
                      1,
                      this.drag.y
                    ));
                  for (let e = 0; e < this.els.length; e++) {
                    const { targ: t, plane: s } = this.els[e];
                    (t.x = this.drag.x),
                      (t.y = this.drag.y),
                      (t.gl.x = s.bounds.large.gl.x + t.x),
                      (t.gl.y = s.bounds.large.gl.y - t.y);
                  }
                }
              }
              onWheel(e) {
                if (this.canDrag || this.forceMove) {
                  (this.isWheeling = !0),
                    (this.wheel.x = c.ZP.utils.clamp(
                      this.drag.min.x,
                      this.drag.max.x,
                      this.wheel.x - e.deltaX
                    )),
                    (this.wheel.y = c.ZP.utils.clamp(
                      this.drag.min.y,
                      this.drag.max.y,
                      this.wheel.y - e.deltaY
                    )),
                    this.wheel.started ||
                    this.onWheelStart(this.wheel.x, this.wheel.y),
                    (this.wheel.started = !0),
                    (this.drag.dragging =
                      Math.abs(this.wheel.y - this.drag.start.y) +
                      Math.abs(this.wheel.y - this.drag.start.x) >=
                      4),
                    (this.drag.x = c.ZP.utils.clamp(
                      this.drag.min.x,
                      this.drag.max.x,
                      this.drag.end.x + this.wheel.x - this.drag.start.x
                    )),
                    (this.drag.y = c.ZP.utils.clamp(
                      this.drag.min.y,
                      this.drag.max.y,
                      this.drag.end.y + this.wheel.y - this.drag.start.y
                    )),
                    (this.drag.normalize.x = c.ZP.utils.mapRange(
                      this.drag.min.x,
                      this.drag.max.x,
                      -1,
                      1,
                      this.drag.x
                    )),
                    (this.drag.normalize.y = c.ZP.utils.mapRange(
                      this.drag.min.y,
                      this.drag.max.y,
                      -1,
                      1,
                      this.drag.y
                    ));
                  for (let e = 0; e < this.els.length; e++) {
                    const { targ: t, plane: s } = this.els[e];
                    (t.x = this.drag.x),
                      (t.y = this.drag.y),
                      (t.gl.x = s.bounds.large.gl.x + t.x),
                      (t.gl.y = s.bounds.large.gl.y - t.y);
                  }
                }
              }
              onWheelStart(e, t) {
                (this.drag.start.x = e),
                  (this.drag.start.y = t),
                  (this.isDown = !0);
              }
              down(e) {
                this.isWheeling ||
                  ((this.drag.start.x = e.changedTouches
                    ? e.changedTouches[0].clientX
                    : e.clientX),
                    (this.drag.start.y = e.changedTouches
                      ? e.changedTouches[0].clientY
                      : e.clientY),
                    (this.isDown = !0));
              }
              up() {
                if (
                  ((this.drag.end.x = this.drag.x),
                    (this.drag.end.y = this.drag.y),
                    (this.isDown = !1),
                    (this.wheel.started = !1),
                    (this.isWheeling = !1),
                    (document.documentElement.style.cursor = "grab"),   
                    this.isDragging)
               
                ) {
                  for (let e = 0; e < this.els.length; e++) {
                    const { plane: t, animation: s } = this.els[e];
                    s.z && (s.z.pause(), s.z.invalidate(), s.z.kill()),
                      (s.z = c.ZP.to(t.mesh.position, {
                        z: 0,
                        ease: "expo.out",
                        duration: 1.2,
                      }));
                  }
                  this.isDragging = !1;
                }
                setTimeout(() => {
                  this.drag.dragging = !1;
                }, 0);
              }
              onClick(e, t) {
                if (this.drag.dragging)
                  return t.preventDefault(), void t.stopPropagation();
                (this.canDrag = !1), (this.currentIndex = e);
                const { plane: s } = this.els[e];
                (h.currentPlane = s),
                  clearInterval(this.mouseEnterInterval),
                  (s.mesh.material.uniforms.uTexture.value = s.texture),
                  (s.mesh.material.uniforms.uImageSize.value = new I.FM8(
                    s.texture.source.data.naturalWidth,
                    s.texture.source.data.naturalHeight
                  ));
                for (let t = 0; t < this.els.length; t++)
                  t !== e &&
                    this.animateAlpha(t, 0, 0.3, c.ZP.utils.random(0, 0.15));
              }
              animateAlpha(e, t) {
                let s =
                  arguments.length > 2 && void 0 !== arguments[2]
                    ? arguments[2]
                    : 0.35,
                  i =
                    arguments.length > 3 && void 0 !== arguments[3]
                      ? arguments[3]
                      : 0,
                  o =
                    !(arguments.length > 4 && void 0 !== arguments[4]) ||
                    arguments[4];
                const { plane: n, animation: r } = this.els[e];
                r.alpha &&
                  (r.alpha.pause(), r.alpha.invalidate(), r.alpha.kill()),
                  (r.alpha = c.ZP.timeline()),
                  r.alpha.to(n.mesh.material.uniforms.uAlpha, {
                    value: t,
                    duration: s,
                    delay: i,
                    ease: "alpha",
                  }),
                  o &&
                  (r.z && (r.z.pause(), r.z.invalidate(), r.z.kill()),
                    r.alpha.to(
                      n.mesh.position,
                      {
                        z: 1 === t ? 0 : -70,
                        duration: 1,
                        ease: "expo.out",
                      },
                      0
                    ));
              }
              setBounds() {
                const e = (h.w.w / 1440) * 150,
                  t = Object.values(this.els).map((e) => e.bounds.top),
                  s = Object.values(this.els).map((e) => e.bounds.bottom),
                  i = Object.values(this.els).map((e) => e.bounds.left),
                  o = Object.values(this.els).map((e) => e.bounds.right);
                (this.drag.max.x = Math.abs(Math.min(Math.min(...i) - e, 0))),
                  (this.drag.min.x = -Math.max(Math.max(...o) - h.w.w + e, 0)),
                  (this.drag.min.y = Math.min(Math.min(...t) - e, 0)),
                  (this.drag.max.y = Math.max(Math.max(...s) - h.w.h + e, 0));
              }
              resize() {
                (this.drag.start.x = 0),
                  (this.drag.start.y = 0),
                  (this.drag.end.x = 0),
                  (this.drag.end.y = 0);
                for (let e = 0; e < this.els.length; e++) {
                  const { dom: t, targ: s, curr: i, plane: o } = this.els[e];
                  (s.x = 0),
                    (s.y = 0),
                    (i.x = 0),
                    (i.y = 0),
                    (this.els[e].bounds = h.grid.els[e].bounds),
                    (t.style.transform = "translate(0, 0)"),
                    o.resize();
                }
                this.setBounds();
              }
              update() {
                (this.drag.normalize.lerp.x = h.lerp(
                  this.drag.normalize.lerp.x,
                  this.drag.normalize.x,
                  0.09
                )),
                  (this.drag.normalize.lerp.y = h.lerp(
                    this.drag.normalize.lerp.y,
                    this.drag.normalize.y,
                    0.09
                  ));
                for (let e = 0; e < this.els.length; e++) {
                  const {
                    dom: t,
                    targ: s,
                    curr: i,
                    lerp: o,
                    plane: n,
                    bounds: r,
                    out: a,
                  } = this.els[e];
                  (i.parallaxAmount = h.lerp(
                    i.parallaxAmount,
                    s.parallaxAmount,
                    o
                  )),
                    (i.x = h.lerp(i.x, s.x, o)),
                    (i.y = h.lerp(i.y, s.y, o)),
                    (i.gl.x = h.lerp(i.gl.x, s.gl.x, o)),
                    (i.gl.y = h.lerp(i.gl.y, s.gl.y, o));
                  const l = r.top + i.y,
                    d = r.right + i.x;
                  l + 0.5 * r.height >= -r.height &&
                    l <= h.w.h + 0.5 * r.height &&
                    d + 0.5 * r.width >= 0 &&
                    d <= h.w.w + 1.5 * r.width
                    ? (a && (n.mesh.visible = !0),
                      (this.els[e].out = !1),
                      (h.unequal(s.x, i.x) || h.unequal(s.y, i.y)) &&
                      ((n.mesh.position.x = i.gl.x),
                        (n.mesh.position.y = i.gl.y),
                        (t.style.transform = `translate3d(${i.x}px, ${i.y}px, 0)`)))
                    : a ||
                    ((this.els[e].out = !0),
                      (n.mesh.visible = !1),
                      (t.style.transform = `translate(${i.x}px, ${i.y}px)`));
                }
              }
            },
          },
        ];
        var Q = J,
          ee = [
            {
              name: "artist",
              Class: class extends E {
                init() {
                  (this.isDown = !1),
                    (this.canDrag = !0),
                    (this.drag = {
                      dragging: !1,
                      start: {
                        x: 0,
                        y: 0,
                      },
                      end: {
                        x: 0,
                        y: 0,
                      },
                      min: {
                        x: 0,
                        y: 0,
                      },
                      max: {
                        x: 0,
                        y: 0,
                      },
                      x: 0,
                      y: 0,
                    }),
                    (this.mm = new T({
                      cb: this.move,
                      mobile: !0,
                    })),
                    (this.filters = new Z({
                      filters: this.$filters,
                      filtersWrapper: this.$filtersWrapper,
                      items: this.$gridEls,
                      onFilter: this.onFilter,
                    })),
                    c.ZP.set(this.$gridElsW, {
                      opacity: 0,
                    }),
                    document.body.classList.add("overflow-hidden"),
                    this.setBounds();
                }
                bindMethods() {
                  (this.move = this.move.bind(this)),
                    (this.down = this.down.bind(this)),
                    (this.up = this.up.bind(this)),
                    (this.onFilter = this.onFilter.bind(this));
                }
                getElems() {
                  (this.els = []),
                    (this.$gridElsW = this.$el.querySelectorAll(".grid-el")),
                    (this.$gridEls = this.$el.querySelectorAll(".grid-el-w")),
                    (this.$indexLink = this.$el.querySelector(".artist-index")),
                    (this.$filters =
                      this.$el.querySelectorAll(".filter-project")),
                    (this.$filtersWrapper =
                      this.$el.querySelector(".filters-project"));
                  for (let e = 0; e < this.$gridEls.length; e++)
                    this.els.push({
                      dom: this.$gridEls[e],
                      bounds: this.$gridEls[e].getBoundingClientRect(),
                      lerp: c.ZP.utils.random(0.08, 0.09),
                      out: !1,
                      targ: {
                        x: 0,
                        y: 0,
                      },
                      curr: {
                        x: 0,
                        y: 0,
                      },
                    });
                }
                events() {
                  window.addEventListener("touchstart", this.down),
                    window.addEventListener("touchend", this.up),
                    this.$indexPopupLink &&
                    this.$indexPopupLink.addEventListener(
                      "click",
                      this.popup.closePopup
                    );
                }
                destroy() {
                  (h.grid.cache[window.location.pathname] = {
                    x: this.drag.x,
                    y: this.drag.y,
                  }),
                    this.mm.off(),
                    this.popup && this.popup.off(),
                    document.body.classList.remove("overflow-hidden"),
                    window.removeEventListener("touchstart", this.down),
                    window.removeEventListener("touchend", this.up),
                    this.$indexPopupLink &&
                    this.$indexPopupLink.removeEventListener(
                      "click",
                      this.popup.closePopup
                    );
                }
                onEnterCompleted() {
                  this.mm.on();
                }
                appear() {
                  c.ZP.fromTo(
                    this.$gridElsW,
                    {
                      scale: 0.7,
                    },
                    {
                      opacity: 1,
                      scale: 1,
                      duration: 1.4,
                      ease: "expo.out",
                      stagger: {
                        each: 0.0275,
                        from: "random",
                      },
                      clearProps: !0,
                    }
                  );
                }
                moveToPrevPosition() {
                  const e = h.grid.cache[window.location.pathname];
                  if (e) {
                    this.canDrag = !0;
                    for (let t = 0; t < this.els.length; t++) {
                      const { targ: s } = this.els[t];
                      (s.x = e.x), (s.y = e.y);
                    }
                    (this.drag.end.x = e.x), (this.drag.end.y = e.y);
                  }
                }
                move(e, t) {
                  if (this.isDown && this.canDrag) {
                    (this.drag.dragging =
                      Math.abs(t - this.drag.start.y) +
                      Math.abs(e - this.drag.start.x) >=
                      4),
                      (this.drag.x = c.ZP.utils.clamp(
                        this.drag.min.x,
                        this.drag.max.x,
                        this.drag.end.x + 2 * e - this.drag.start.x
                      )),
                      (this.drag.y = c.ZP.utils.clamp(
                        this.drag.min.y,
                        this.drag.max.y,
                        this.drag.end.y + 2 * t - this.drag.start.y
                      ));
                    for (let e = 0; e < this.els.length; e++) {
                      const { targ: t } = this.els[e];
                      (t.x = h.round(this.drag.x)), (t.y = h.round(this.drag.y));
                    }
                  }
                }
                down(e) {
                  (this.drag.start.x = e.changedTouches
                    ? 2 * e.changedTouches[0].clientX
                    : 2 * e.clientX),
                    (this.drag.start.y = e.changedTouches
                      ? 2 * e.changedTouches[0].clientY
                      : 2 * e.clientY),
                    (this.isDown = !0);
                }
                up() {
                  (this.drag.end.x = this.drag.x),
                    (this.drag.end.y = this.drag.y),
                    (this.isDown = !1),
                    setTimeout(() => {
                      this.drag.dragging = !1;
                    }, 0);
                }
                openPopup() {
                  return new Promise((e) => {
                    (this.canDrag = !1),
                      this.$biographyLink.classList.toggle("a"),
                      this.$indexLink.classList.toggle("a"),
                      c.ZP.timeline({
                        defaults: {
                          ease: "expo.out",
                          duration: 1,
                        },
                        onComplete: () => {
                          e();
                        },
                      })
                        .to(
                          [this.$popupWrapper, this.$popupInner],
                          {
                            yPercent: 0,
                          },
                          0
                        )
                        .textReveal(this.popup.content, {}, "<10%");
                  });
                }
                closePopup() {
                  return new Promise((e) => {
                    (this.canDrag = !0),
                      this.$biographyLink.classList.toggle("a"),
                      this.$indexLink.classList.toggle("a"),
                      c.ZP.timeline({
                        defaults: {
                          ease: "expo.out",
                          duration: 1,
                        },
                        onComplete: () => {
                          c.ZP.set(this.popup.content.linesChars, {
                            opacity: 0,
                          }),
                            e();
                        },
                      })
                        .to(
                          this.$popupWrapper,
                          {
                            yPercent: -100,
                          },
                          0
                        )
                        .to(
                          this.$popupInner,
                          {
                            yPercent: 100,
                          },
                          0
                        );
                  });
                }
                onFilter(e, t) {
                  for (let e = 0; e < this.els.length; e++) {
                    const { dom: s } = this.els[e],
                      i = s.dataset.filter.split(",");
                    s.children[0].classList.toggle(
                      "pointer-events-auto",
                      i.includes(t) || -1 === t
                    ),
                      s.classList.toggle("a", !i.includes(t) && -1 !== t);
                  }
                }
                setBounds() {
                  const e = (h.w.w / 1440) * 200;
                  let t = (h.w.w / 1440) * 200;
                  const s = Object.values(this.els).map((e) => e.bounds.top),
                    i = Object.values(this.els).map((e) => e.bounds.bottom),
                    o = Object.values(this.els).map((e) => e.bounds.left),
                    n = Object.values(this.els).map((e) => e.bounds.right);
                  h.w.w <= 1024 && h.w.w > 768
                    ? (t = (h.w.w / 1024) * 200)
                    : h.w.w <= 768 && h.w.w > 390
                      ? (t = (h.w.w / 768) * 200)
                      : h.w.w <= 390 && (t = (h.w.w / 390) * 150),
                    (this.drag.min.x = Math.min(Math.min(...o) - e, 0)),
                    (this.drag.max.x = Math.max(Math.max(...n) - h.w.w + e, 0)),
                    (this.drag.min.y = Math.min(Math.min(...s) - t, 0)),
                    (this.drag.max.y = Math.max(Math.max(...i) - h.w.h + e, 0));
                }
                resize() {
                  (this.drag.start.x = 0),
                    (this.drag.start.y = 0),
                    (this.drag.end.x = 0),
                    (this.drag.end.y = 0);
                  for (let e = 0; e < this.els.length; e++) {
                    const { dom: t, targ: s, curr: i } = this.els[e];
                    (s.x = 0),
                      (s.y = 0),
                      (i.x = 0),
                      (i.y = 0),
                      (t.style.transform = "translate(0, 0)"),
                      (this.els[e].bounds = t.getBoundingClientRect());
                  }
                  this.setBounds();
                }
                update() {
                  if (this.canDrag)
                    for (let e = 0; e < this.els.length; e++) {
                      const {
                        dom: t,
                        targ: s,
                        curr: i,
                        lerp: o,
                        bounds: n,
                        out: r,
                      } = this.els[e];
                      (i.x = h.round(h.lerp(i.x, s.x, o))),
                        (i.y = h.round(h.lerp(i.y, s.y, o)));
                      const a = n.top + i.y,
                        l = n.right + i.x;
                      if (
                        a >= -n.height - 50 &&
                        a <= h.w.h &&
                        l >= 0 &&
                        l <= h.w.w + n.width
                      ) {
                        this.els[e].out = !1;
                        const o = h.unequal(s.x, i.x) || h.unequal(s.y, i.y);
                        t.style.transform = o
                          ? `translate3d(${i.x}px, ${i.y}px, 0)`
                          : `translate(${i.x}px, ${i.y}px)`;
                      } else
                        r ||
                          ((this.els[e].out = !0),
                            (t.style.transform = `translate(${i.x}px, ${i.y}px)`));
                    }
                }
              },
            },
          ];
        class te extends r.Th {
          onEnter() {
            (this.blockList = h.detect.isMobile ? ee : Q),
              (this.blocks = []),
              this.blockList && this.blockList.length && this.initBlocks(),
              h.detect.isMobile &&
              ((this.screensElements =
                document.body.querySelectorAll(".h-screen")),
                this.screensElements.length &&
                c.ZP.set(this.screensElements, {
                  height: h.w.h,
                }));
          }
          initBlocks() {
            for (let e = 0; e < this.blockList.length; e++) {
              const t = this.content.querySelectorAll(
                "." + this.blockList[e].name
              ),
                s = {
                  name: this.blockList[e].name,
                  instances: [],
                };
              for (let i = 0; i < t.length; i++) {
                const o = {
                  el: t[i],
                  class: new this.blockList[e].Class(t[i]),
                };
                s.instances.push(o);
              }
              this.blocks.push(s);
            }
          }
          onEnterCompleted() {
            for (let e = 0; e < this.blocks.length; e++)
              for (let t = 0; t < this.blocks[e].instances.length; t++)
                this.blocks[e].instances[t].class.onEnterCompleted();
            h.isFirstLoaded
              ? this.appear()
              : window.addEventListener(
                "loaderComplete",
                this.appear.bind(this),
                {
                  once: !0,
                }
              );
          }
          appear() {
            for (let e = 0; e < this.blocks.length; e++)
              for (let t = 0; t < this.blocks[e].instances.length; t++)
                this.blocks[e].instances[t].class.appear();
          }
          onLeave() {
            for (let e = 0; e < this.blocks.length; e++)
              for (let t = 0; t < this.blocks[e].instances.length; t++)
                this.blocks[e].instances[t].class.destroyLast ||
                  this.blocks[e].instances[t].class.destroy();
          }
          onLeaveCompleted() {
            for (let e = 0; e < this.blocks.length; e++)
              for (let t = 0; t < this.blocks[e].instances.length; t++)
                this.blocks[e].instances[t].class.destroyLast &&
                  this.blocks[e].instances[t].class.destroy();
          }
          resize() {
            h.detect.isMobile &&
              this.screensElements &&
              this.screensElements.length &&
              c.ZP.set(this.screensElements, {
                height: h.w.h,
              });
            for (let e = 0; e < this.blocks.length; e++)
              for (let t = 0; t < this.blocks[e].instances.length; t++)
                this.blocks[e].instances[t].class.resize();
          }
          scroll(e) {
            for (let t = 0; t < this.blocks.length; t++)
              for (let s = 0; s < this.blocks[t].instances.length; s++)
                this.blocks[t].instances[s].class.scroll(e);
          }
          loop() {
            for (let e = 0; e < this.blocks.length; e++)
              for (let t = 0; t < this.blocks[e].instances.length; t++)
                this.blocks[e].instances[t].class.update();
          }
        }
        class se extends r.uT {
          onLeave(e) {
            let { from: t, done: s } = e;
            h.smoothScroll && h.smoothScroll.stop(),
              (h.router.from = t.dataset.template),
              (h.navigating = !0),
              !h.detect.isMobile &&
              "single-realisation" === t.dataset.template &&
              h.nextPlane.remove(),
              h.cursor && h.cursor.loading(),
              c.ZP.to(h.fade, {
                autoAlpha: 1,
                duration: 0.3,
                ease: "alpha",
                onComplete: () => {
                  h.smoothScroll &&
                    h.smoothScroll.scrollTo(0, {
                      immediate: !0,
                      force: !0,
                    }),
                    s();
                },
              });
          }
          onEnter(e) {
            let { to: t, done: s } = e;
            const i = c.ZP.timeline({
              paused: !0,
            });
            i
              .to(h.fade, {
                autoAlpha: 0,
                duration: 0.3,
                ease: "alpha",
                onComplete: () => {
                  h.smoothScroll.__isStopped && h.smoothScroll.start();
                },
              })
              .call(
                () => {
                  (h.navigating = !1), s();
                },
                [],
                0.1
              ),
              h.detect.isMobile || "single-realisation" !== t.dataset.template
                ? h.textures[window.location.pathname]
                  ? h.emitter.on("textures-loaded", () => {
                    h.cursor && h.cursor.loaded(),
                      h.emitter.off("textures-loaded"),
                      (h.textures[window.location.pathname] = null),
                      i.play();
                  })
                  : (h.cursor && h.cursor.loaded(), i.play())
                : h.emitter.on("realisation-ready", () => {
                  h.cursor && h.cursor.loaded(),
                    h.emitter.off("realisation-ready"),
                    i.play();
                });
          }
        }
        var ie = s("../node_modules/three/examples/jsm/loaders/GLTFLoader.js"),
          oe = s("../node_modules/three/examples/jsm/controls/OrbitControls.js");
        class ne {
          constructor() {
            (this.gl = new he()),
              (this.scene = this.gl.scene),
              (this.canvas = this.gl.canvas),
              this.setInstance();
          }
          setInstance() {
            const { w: e, h: t } = h.w,
              s = (2 * Math.atan(t / 2 / 500) * 180) / Math.PI;
            (this.instance = new I.cPb(s, e / t, 1, 1e3)),
              this.instance.position.set(0, 0, 500),
              this.scene.add(this.instance);
          }
          setOrbitControls() {
            (this.controls = new oe.z(this.instance, this.canvas)),
              (this.controls.enableDamping = !0),
              (this.canvas.style.pointerEvents = "all");
          }
          resize() {
            const e = (2 * Math.atan(h.w.h / 2 / 500) * 180) / Math.PI;
            (this.instance.fov = e),
              (this.instance.aspect = h.w.w / h.w.h),
              this.instance.updateProjectionMatrix();
          }
          update() {
            this.controls && this.controls.update();
          }
        }
        class re {
          constructor() {
            (this.gl = h.GL),
              (this.canvas = this.gl.canvas),
              (this.scene = this.gl.scene),
              (this.camera = this.gl.camera),
              this.setInstance();
          }
          setInstance() {
            (this.instance = new I.CP7({
              canvas: this.canvas,
              alpha: !0,
              antialias: !0,
            })),
              this.instance.setSize(h.w.w, h.w.h),
              this.instance.setPixelRatio(h.w.pR);
          }
          resize() {
            this.instance.setSize(h.w.w, h.w.h),
              this.instance.setPixelRatio(h.w.pR);
          }
          update() {
            this.instance.render(this.scene, this.camera.instance);
          }
        }
        class ae {
          constructor() {
            document.body.classList.add("debug"),
              (this.gl = h.GL),
              this.addDebugUI(),
              this.addDebugCamera(),
              this.addDebugScene();
          }
          addDebugUI() {
            h.debug
              .addButton({
                title: "Show debug UI 👀",
              })
              .on("click", () => document.body.classList.toggle("debug"));
          }
          addDebugScene() {
            const e = h.debug.addFolder({
              title: "Scene 👀",
            });
            this.sceneChildrens = e.addBlade({
              view: "text",
              label: "Childrens",
              parse: (e) => String(e),
              value: "0",
              disabled: !0,
            });
          }
          setSceneChildrens(e) {
            this.sceneChildrens.controller_.valueController.value.rawValue = e;
          }
          addDebugCamera() {
            const e = document.querySelector(".viewport-debug"),
              t = h.debug
                .addFolder({
                  title: "Camera 📹",
                })
                .addButton({
                  title: "Toggle debug view",
                });
            let s = !1;
            t.on("click", () => {
              (s = !s),
                e.classList.toggle("a", s),
                (this.gl.camera.instance.position.z = s ? 1e3 : 500);
            });
          }
        }
        let le = null;
        class he {
          constructor(e) {
            if (le) return le;
            (le = this),
              (h.GL = this),
              (window.GL = this),
              (this.w = {
                ww: window.innerWidth,
                wh: window.innerHeight,
                pR: Math.min(window.devicePixelRatio, 1.5),
              }),
              (this.canvas = e.canvas),
              (this.cache = {}),
              (this.planes = []),
              this.createLoaders(),
              (this.scene = new I.xsS()),
              (this.camera = new ne()),
              (this.renderer = new re()),
              h.showDebug && (this.debug = new ae());
          }
          createLoaders() {
            (this.textureLoader = new I.dpR()), (this.gltfLoader = new ie.E());
          }
          resize() {
            this.camera.resize(), this.renderer.resize();
            for (let e = 0; e < this.planes.length; e++) this.planes[e].resize();
          }
          update() {
            this.camera.update(), this.renderer.update();
          }
          destroy() { }
        }
        class me {
          constructor() {
            (this.initSmoothScroll = this.initSmoothScroll.bind(this)),
              (this.resize = this.resize.bind(this)),
              (this.scroll = this.scroll.bind(this)),
              (this.update = this.update.bind(this)),
              (this.resizeDebounced = (0, a.D)(250, this.resize)),
              (this.scrollDebounced = (0, a.D)(100, this.scroll)),
              (this.scrollThrottled = (0, a.P)(30, this.scroll)),
              (h.emitter = new (v())()),
              c.ZP.registerPlugin(u.t),
              u.t.create("alpha", ".25, .46, .45, .9"),
              c.ZP.registerPlugin(m.i),
              (h.scrollTrigger = m.i),
              (h.w = {
                w: window.innerWidth,
                h: window.innerHeight,
                pR: Math.min(window.devicePixelRatio, 1.5),
              }),
              h.detect.isMobile &&
              document.documentElement.style.setProperty(
                "--wh",
                h.w.h / 100 + "px"
              ),
              (h.showDebug =
                "#debug" === window.location.hash &&
                document.body.classList.contains("has-debug")),
              h.showDebug &&
              ((h.debug = new p.Pane({
                title: "GUI",
              })),
                h.debug.registerPlugin(y),
                (this.fpsGraph = h.debug.addBlade({
                  view: "fpsgraph",
                  label: "fpsgraph",
                  lineCount: 2,
                }))),
              this.start(),
              h.GL &&
              h.GL.debug &&
              h.GL.debug.setSceneChildrens(h.GL.scene.children.length);
          }
          start() {
            if (
              (history.scrollRestoration &&
                (history.scrollRestoration = "manual"),
                (h.fade = document.querySelector(".fade")),
                h.detect.isMobile)
            ) {
              const e = document.querySelector(".cursor");
              e && e.classList.add("hidden");
            } else {
              h.cursor = new k();
              const e = document.querySelector("#tarteaucitronAlertBig");
              e &&
                e.addEventListener("mouseenter", () => {
                  h.cursor.hide();
                });
            }
            this.addCustomSplitting(),
              this.initSmoothScroll(),
              (h.initSmoothScroll = this.initSmoothScroll),
              h.detect.isMobile ||
              (this.GL = new he({
                canvas: document.querySelector("#gl"),
              })),
              this.setupGrid(),
              this.initTaxi(),
              (this.loader = new S()),
              (this.lazyLoad = new (n())()),
              this.events(),
              requestAnimationFrame(this.update);
          }
          initTaxi() {
            (this.taxi = new r.QY({
              links:
                "a:not([target]):not([href^=\\#]):not([data-taxi-ignore]):not(.ab-item)",
              reloadJsFilter: (e) => void 0 !== e.dataset.taxiReload,
              transitions: {
                default: se,
                nextRealisation: h.detect.isMobile ? se : se,
                project: h.detect.isMobile ? se : se,
                artist: h.detect.isMobile ? se : se,
              },
              renderers: {
                default: te,
              },
            })),
              (h.router = this.taxi),
              (this.currentRenderer = this.taxi.currentCacheEntry.renderer);
          }
          initSmoothScroll(e) {
            h.smoothScroll && h.smoothScroll.destroy(),
              (h.smoothScroll = new d.Z({
                easing: (e) => 1 - Math.pow(1 - e, 5),
                infinite: e,
              })),
              (window.lenis = h.smoothScroll),
              h.smoothScroll.on("scroll", (e) => {
                h.cursor && !h.cursor.moved && h.cursor.scrollUpdated(),
                  this.scroll(e);
              });
          }
          setupGrid() {
            (h.grid.els = []),
              (h.grid.currentPlanes = []),
              (h.grid.cache = []),
              (h.grid.artists = window.artistsGrid);
            const e = document.querySelectorAll(".grid-images .grid-el");
            for (let t = 0; t < e.length; t++) {
              const s = e[t].getBoundingClientRect();
              h.grid.els.push({
                index: t,
                dom: e[t],
                bounds: s,
              });
            }
          }
          addCustomSplitting() {
            w().add({
              by: "linesChars",
              key: "linesChars",
              depends: ["lines"],
              split: (e, t, s) => {
                const i = [];
                return (
                  s.lines.forEach((e, t) => {
                    (i[t] = []),
                      e.forEach((e) => {
                        const s = e.innerText.split("");
                        (e.innerHTML = ""),
                          s.forEach((s) => {
                            const o = document.createElement("span");
                            (o.dataset.char = s),
                              (o.innerText = s),
                              e.appendChild(o),
                              i[t].push(o);
                          });
                      });
                  }),
                  i
                );
              },
            }),
              w().add({
                by: "wrapLinesChars",
                key: "linesChars",
                depends: ["lines"],
                split: (e, t, s) => {
                  const i = [];
                  return (
                    (e.innerHTML = ""),
                    s.lines.forEach((t, s) => {
                      i[s] = [];
                      const o = document.createElement("div");
                      o.classList.add("w-line"),
                        t.forEach((e, n) => {
                          const r = e.innerText.split("");
                          if (
                            ((e.innerHTML = ""),
                              r.forEach((t) => {
                                const o = document.createElement("span");
                                (o.dataset.char = t),
                                  (o.innerText = t),
                                  e.appendChild(o),
                                  i[s].push(o);
                              }),
                              o.appendChild(e),
                              n < t.length - 1)
                          ) {
                            const e = document.createElement("span");
                            e.classList.add("whitespace"),
                              (e.innerHTML = " "),
                              o.appendChild(e);
                          }
                        }),
                        e.appendChild(o);
                    }),
                    e.classList.add("flex", "flex-col", "items-center"),
                    i
                  );
                },
              });
          }
          reloadTartaucitronServices() {
            if (!window.tarteaucitron) return;
            const e = document.body.querySelectorAll(".tarteaucitronAllow");
            for (let t = 0; t < e.length; t++)
              window.tarteaucitron.addClickEventToElement(e[t], function () {
                window.tarteaucitron.userInterface.respond(this, !0);
              });
          }
          resize() {
            (h.w = {
              w: window.innerWidth,
              h: window.innerHeight,
              pR: Math.min(window.devicePixelRatio, 1.5),
            }),
              h.detect.isMobile &&
              document.documentElement.style.setProperty(
                "--wh",
                h.w.h / 100 + "px"
              );
            for (let e = 0; e < h.grid.els.length; e++) {
              const { dom: t } = h.grid.els[e];
              h.grid.els[e].bounds = t.getBoundingClientRect();
            }
            this.GL && this.GL.resize(),
              this.currentRenderer.resize(),
              h.cursor && h.cursor.resize(),
              h.largePlayer && h.largePlayer.resize();
          }
          scroll(e) {
            (h.currentScroll = window.scrollY),
              this.currentRenderer && this.currentRenderer.scroll(e);
          }
          update(e) {
            h.showDebug && this.fpsGraph.begin(),
              h.smoothScroll && h.smoothScroll.raf(e),
              h.cursor && h.cursor.update(),
              h.largePlayer && h.largePlayer.update(),
              this.currentRenderer.loop(),
              this.GL && this.GL.update(),
              h.showDebug && this.fpsGraph.end(),
              requestAnimationFrame(this.update);
          }
          events() {
            window.addEventListener("resize", this.resizeDebounced),
              window.addEventListener("orientationchange", this.resize),
              window.addEventListener("wheel", this.scrollThrottled),
              window.addEventListener("wheel", this.scrollDebounced),
              this.taxi.on("NAVIGATE_IN", (e) => {
                let { to: t } = e;
                this.currentRenderer = t.renderer;
              }),
              this.taxi.on("NAVIGATE_OUT", (e) => {
                let { location: t } = e;
                this.menu.onPageChange(t, !0);
              }),
              this.taxi.on("NAVIGATE_END", (e) => {
                let { to: t } = e;
                this.updateTracking(t),
                  h.header.onPageChange({
                    location,
                  }),
                  this.reloadTartaucitronServices(),
                  this.updateLinks(),
                  this.lazyLoad.update(),
                  h.GL &&
                  h.GL.debug &&
                  h.GL.debug.setSceneChildrens(h.GL.scene.children.length);
              });
          }
          updateTracking(e) {
            void 0 !== window.gtag &&
              window.gtag("event", "page_view", {
                page_path: window.location.pathname,
                page_title: e.page.title,
                page_location: window.location.href,
              });
          }
          preloadPages() {
            this.prefetchedPages || (this.prefetchedPages = []),
              (this.pageLinks = document.body.querySelectorAll(
                ".header a:not(.ab-item), .content a:not(.ab-item)"
              )),
              this.pageLinks.forEach((e) => {
                -1 === this.prefetchedPages.indexOf(e.href) &&
                  e.href.includes(window.location.origin) &&
                  (this.prefetchedPages.push(e.href), this.taxi.preload(e.href));
              });
          }
        }
        class pe {
          constructor() {
            (this.grid = document.querySelector(".debug-grid")),
              this.grid && this.addEvents();
          }
        }
        const ge = async (e) => {
          e && console.error(e),
            setTimeout(() => {
              new me();
            }, 50),
            new pe();
        };
        (0, i.Z)(ge);
      },
      "./scripts/GL/shaders/about-plane/about-plane.frag": (e) => {
        e.exports =
          "precision highp float;\nuniform sampler2D uTexture;\nuniform vec2 uMeshSize;\nuniform vec2 uImageSize;\nuniform float uAlpha;\nvarying vec2 vUv;\nvec2 aspect(in vec2 size, in float scale) {\n\treturn scale / size;\n}\nvec2 aspectCover(vec2 uv, vec2 imageSize, vec2 meshSize) {\n\tvec2 sizeRatio = imageSize / meshSize;\n\tvec2 newSize = aspect(sizeRatio, min(sizeRatio.x, sizeRatio.y));\n\tvec2 centeredSize = (uv * newSize) + ((1. - newSize) * 0.5);\n\treturn centeredSize;\n}\nvec2 aspectContain(vec2 uv, vec2 imageSize, vec2 meshSize) {\n\tvec2 sizeRatio = imageSize / meshSize;\n\tvec2 newSize = aspect(sizeRatio, max(sizeRatio.x, sizeRatio.y));\n\tvec2 centeredSize = (uv * newSize) + ((1. - newSize) * 0.5);\n\treturn centeredSize;\n}\nvoid main() {\n\tvec2 imageTexUv = aspectContain(vUv, uImageSize, uMeshSize);\n\tvec4 imageTex = texture2D(uTexture, imageTexUv);\n\tvec2 imageLimit = abs(floor(imageTexUv));\n\tvec4 imageCropped = mix(vec4(1, 1, 1, 0.), imageTex, step(max(imageLimit.x, imageLimit.y), 0.));\n\tgl_FragColor = vec4(imageCropped.rgb, uAlpha);\n}\n";
      },
      "./scripts/GL/shaders/about-plane/about-plane.vert": (e) => {
        e.exports =
          "varying vec2 vUv;\nvoid main() {\n\tvUv = uv;\n\tgl_Position = (projectionMatrix * modelViewMatrix) * vec4(position, 1.0);\n}\n";
      },
      "./scripts/GL/shaders/object/object.frag": (e) => {
        e.exports =
          "uniform sampler2D uSceneTexture;\nuniform sampler2D uDiffuse;\nuniform vec2 uResolution;\nuniform float uScroll;\nuniform float uIOR;\nuniform float uRefractIntensity;\nuniform float uRefractPower;\nuniform float uDistortionScale;\nuniform float uDistortionIntensity;\nuniform float uSpecularIntensity;\nuniform float uShininess;\nuniform float uDiffuseness;\nuniform vec3 uLight;\nuniform float uFresnelPower;\nuniform float uFresnelIntensity;\nuniform vec3 uGlassColor;\nuniform float uGlassColorIntensity;\nuniform float uSaturationIntensity;\nuniform float uColorShift;\nuniform float uAlpha;\nuniform float uColorMix;\nvarying vec2 vUv;\nvarying vec3 vWorldNormal;\nvarying vec3 vEyeVector;\nvarying vec3 vNormal;\nvarying vec3 vPosition;\nvec3 mod289(vec3 x) {\n\treturn x - (floor(x * (1.0 / 289.0)) * 289.0);\n}\nvec4 mod289(vec4 x) {\n\treturn x - (floor(x * (1.0 / 289.0)) * 289.0);\n}\nvec4 permute(vec4 x) {\n\treturn mod289(((x * 34.0) + 1.0) * x);\n}\nvec4 taylorInvSqrt(vec4 r) {\n\treturn 1.79284291400159 - (0.85373472095314 * r);\n}\nfloat snoise(vec3 v) {\n\tconst vec2 C = vec2(1.0 / 6.0, 1.0 / 3.0);\n\tconst vec4 D = vec4(0.0, 0.5, 1.0, 2.0);\n\tvec3 i = floor(v + dot(v, C.yyy));\n\tvec3 x0 = (v - i) + dot(i, C.xxx);\n\tvec3 g_0 = step(x0.yzx, x0.xyz);\n\tvec3 l = 1.0 - g_0;\n\tvec3 i1 = min(g_0.xyz, l.zxy);\n\tvec3 i2 = max(g_0.xyz, l.zxy);\n\tvec3 x1 = (x0 - i1) + C.xxx;\n\tvec3 x2 = (x0 - i2) + C.yyy;\n\tvec3 x3 = x0 - D.yyy;\n\ti = mod289(i);\n\tvec4 p = permute((permute((permute(i.z + vec4(0.0, i1.z, i2.z, 1.0)) + i.y) + vec4(0.0, i1.y, i2.y, 1.0)) + i.x) + vec4(0.0, i1.x, i2.x, 1.0));\n\tfloat n_ = 0.142857142857;\n\tvec3 ns = (n_ * D.wyz) - D.xzx;\n\tvec4 j = p - (49.0 * floor((p * ns.z) * ns.z));\n\tvec4 x_ = floor(j * ns.z);\n\tvec4 y_ = floor(j - (7.0 * x_));\n\tvec4 x = (x_ * ns.x) + ns.yyyy;\n\tvec4 y = (y_ * ns.x) + ns.yyyy;\n\tvec4 h = (1.0 - abs(x)) - abs(y);\n\tvec4 b0 = vec4(x.xy, y.xy);\n\tvec4 b1 = vec4(x.zw, y.zw);\n\tvec4 s0 = (floor(b0) * 2.0) + 1.0;\n\tvec4 s1 = (floor(b1) * 2.0) + 1.0;\n\tvec4 sh = -step(h, vec4(0.0));\n\tvec4 a0 = b0.xzyw + (s0.xzyw * sh.xxyy);\n\tvec4 a1 = b1.xzyw + (s1.xzyw * sh.zzww);\n\tvec3 p0 = vec3(a0.xy, h.x);\n\tvec3 p1 = vec3(a0.zw, h.y);\n\tvec3 p2 = vec3(a1.xy, h.z);\n\tvec3 p3 = vec3(a1.zw, h.w);\n\tvec4 norm = taylorInvSqrt(vec4(dot(p0, p0), dot(p1, p1), dot(p2, p2), dot(p3, p3)));\n\tp0 *= norm.x;\n\tp1 *= norm.y;\n\tp2 *= norm.z;\n\tp3 *= norm.w;\n\tvec4 m = max(0.6 - vec4(dot(x0, x0), dot(x1, x1), dot(x2, x2), dot(x3, x3)), 0.0);\n\tm = m * m;\n\treturn 42.0 * dot(m * m, vec4(dot(p0, x0), dot(p1, x1), dot(p2, x2), dot(p3, x3)));\n}\n#define LUMINANCE vec3(0.2125, 0.7154, 0.0721)\n#define COLOR_SHIFT_SAMPLE 12\nvec3 sat(vec3 rgb, float intensity) {\n\tvec3 grayscale = vec3(dot(rgb, LUMINANCE));\n\treturn mix(grayscale, rgb, intensity);\n}\nfloat specular(vec3 light, float shininess, float diffuseness) {\n\tvec3 normal = vWorldNormal;\n\tvec3 lightVector = normalize(-light);\n\tvec3 halfVector = normalize(vEyeVector + lightVector);\n\tfloat NdotL = dot(normal, lightVector);\n\tfloat NdotH = dot(normal, halfVector);\n\tfloat kDiffuse = max(0.0, NdotL);\n\tfloat NdotH2 = NdotH * NdotH;\n\tfloat kSpecular = pow(NdotH2, shininess);\n\treturn kSpecular + (kDiffuse * diffuseness);\n}\nfloat fresnel(vec3 eyeVector, vec3 worldNormal, float power) {\n\tfloat fresnelFactor = abs(dot(eyeVector, worldNormal));\n\tfloat inversefresnelFactor = 1.0 - fresnelFactor;\n\treturn pow(inversefresnelFactor, power);\n}\nvoid main() {\n\tgl_FragColor = vec4(vec3(.0), 1.);\n\tfloat distortion = uDistortionIntensity * snoise(vPosition * uDistortionScale);\n\tvec3 normal = vWorldNormal;\n\tvec2 uv = (gl_FragCoord.xy + vec2(.0, uScroll)) / uResolution.xy;\n\tfor (int i = 0; i < COLOR_SHIFT_SAMPLE; i++) {\n\t\tfloat slide = (float(i) / float(COLOR_SHIFT_SAMPLE)) * 0.1;\n\t\tvec3 refractVecR = refract(vEyeVector, normal + distortion, uIOR);\n\t\tvec3 refractVecG = refract(vEyeVector, normal + distortion, uIOR * (1. + uColorShift));\n\t\tvec3 refractVecB = refract(vEyeVector, normal + distortion, uIOR * (1. - uColorShift));\n\t\tvec4 refractedTextureR = texture2D(uSceneTexture, uv + (((uRefractPower + (slide * 1.0)) * uRefractIntensity) * refractVecR.xy));\n\t\tvec4 refractedTextureG = texture2D(uSceneTexture, uv + (((uRefractPower + (slide * 2.0)) * uRefractIntensity) * refractVecG.xy));\n\t\tvec4 refractedTextureB = texture2D(uSceneTexture, uv + (((uRefractPower + (slide * 3.0)) * uRefractIntensity) * refractVecB.xy));\n\t\tgl_FragColor.r += refractedTextureR.r;\n\t\tgl_FragColor.g += refractedTextureG.g;\n\t\tgl_FragColor.b += refractedTextureB.b;\n\t}\n\tgl_FragColor.rgb /= float(COLOR_SHIFT_SAMPLE);\n\tfloat specularLight = specular(uLight, uShininess, uDiffuseness);\n\tgl_FragColor += (specularLight * uSpecularIntensity);\n\tfloat f = uFresnelIntensity * fresnel(vEyeVector, normal, uFresnelPower);\n\tgl_FragColor += (f * vec4(.55));\n\tvec3 diffuse = vec3(0.);\n\tvec3 glassColor = mix(vec3(0.23, 0.04, 0.65), uGlassColor, uColorMix);\n\tdiffuse.r = pow(glassColor.r, uGlassColorIntensity);\n\tdiffuse.g = pow(glassColor.g, uGlassColorIntensity);\n\tdiffuse.b = pow(glassColor.b, uGlassColorIntensity);\n\tdiffuse = sat(diffuse, uSaturationIntensity);\n\tgl_FragColor.rgb *= diffuse;\n\tgl_FragColor.a = uAlpha;\n}\n";
      },
      "./scripts/GL/shaders/object/object.vert": (e) => {
        e.exports =
          "varying vec2 vUv;\nvarying vec3 vPosition;\nvarying vec3 vWorldNormal;\nvarying vec3 vNormal;\nvarying vec3 vEyeVector;\nvoid main() {\n\tvUv = uv;\n\tvPosition = position;\n\tvec4 worldPos = modelMatrix * vec4(position, 1.0);\n\tvec4 mvPosition = viewMatrix * worldPos;\n\tvEyeVector = normalize(worldPos.xyz - cameraPosition);\n\tvec3 transformedNormal = normalMatrix * normal;\n\tvWorldNormal = normalize(transformedNormal);\n\tvNormal = normal;\n\tgl_Position = projectionMatrix * mvPosition;\n}\n";
      },
      "./scripts/GL/shaders/plane/plane.frag": (e) => {
        e.exports =
          "precision highp float;\nuniform sampler2D uTexture;\nuniform sampler2D uVideoTexture;\nuniform vec2 iResolution;\nuniform vec2 uMeshSize;\nuniform vec2 uImageSize;\nuniform vec2 uVideoSize;\nuniform float uVideoFormat;\nuniform float uAlpha;\nuniform float uFade;\nuniform float uProgress;\nuniform float uActive;\nuniform float uScale;\nuniform float uParallaxX;\nuniform float uParallaxY;\nuniform float uParallaxAmount;\nuniform float uTranslateY;\nvarying vec2 vUv;\nvec2 aspect(in vec2 size, in float scale) {\n\treturn scale / size;\n}\nvec2 aspectCover(vec2 uv, vec2 imageSize, vec2 meshSize) {\n\tvec2 sizeRatio = imageSize / meshSize;\n\tvec2 newSize = aspect(sizeRatio, min(sizeRatio.x, sizeRatio.y));\n\tvec2 centeredSize = (uv * newSize) + ((1. - newSize) * 0.5);\n\treturn centeredSize;\n}\nvec2 aspectContain(vec2 uv, vec2 imageSize, vec2 meshSize) {\n\tvec2 sizeRatio = imageSize / meshSize;\n\tvec2 newSize = aspect(sizeRatio, max(sizeRatio.x, sizeRatio.y));\n\tvec2 centeredSize = (uv * newSize) + ((1. - newSize) * 0.5);\n\treturn centeredSize;\n}\nvec3 l(vec3 a, float b) {\n\treturn abs(a - b);\n}\nvoid main() {\n\tvec2 imageTexUv = aspectCover(vUv, uImageSize, uMeshSize);\n\timageTexUv = ((imageTexUv - 0.5) * uScale) + 0.5;\n\timageTexUv.x += ((((1. - uScale) / 2.) * uParallaxX) * uParallaxAmount);\n\timageTexUv.y -= ((((1. - uScale) / 2.) * uParallaxY) * uParallaxAmount);\n\timageTexUv.y -= uTranslateY;\n\tvec4 imageTex = texture2D(uTexture, imageTexUv);\n\tvec2 videoTexUv = uVideoFormat == 0. ? aspectContain(vUv, uVideoSize, uMeshSize) : aspectCover(vUv, uVideoSize, uMeshSize);\n\tvec4 videoTex = texture2D(uVideoTexture, videoTexUv);\n\tvec2 videoLimit = abs(floor(videoTexUv));\n\tvec4 videoCropped = mix(vec4(0, 0, 0, 1), videoTex, step(max(videoLimit.x, videoLimit.y), 0.));\n\tvec4 finalTex = mix(imageTex, videoCropped, uFade);\n\tgl_FragColor = vec4(finalTex.rgb, uAlpha);\n}\n";
      },
      "./scripts/GL/shaders/plane/plane.vert": (e) => {
        e.exports =
          "varying vec2 vUv;\nvoid main() {\n\tvUv = uv;\n\tgl_Position = (projectionMatrix * modelViewMatrix) * vec4(position, 1.0);\n}\n";
      },
      "./scripts/GL/shaders/plane/planeHome.frag": (e) => {
        e.exports =
          "uniform vec2 uMeshSize;\nuniform vec2 uImageSize;\nuniform float uTime;\nuniform float uOpacity;\nuniform float uAlpha;\nuniform sampler2D uTexture;\nuniform sampler2D uVideoTexture;\nvarying vec2 vUv;\nvec2 aspect(in vec2 size, in float scale) {\n\treturn scale / size;\n}\nvec2 aspectCover(vec2 uv, vec2 imageSize, vec2 meshSize) {\n\tvec2 sizeRatio = imageSize / meshSize;\n\tvec2 newSize = aspect(sizeRatio, min(sizeRatio.x, sizeRatio.y));\n\tvec2 centeredSize = (uv * newSize) + ((1. - newSize) * 0.5);\n\treturn centeredSize;\n}\nfloat rand(vec2 co) {\n\treturn fract(sin(dot(co.xy, vec2(2.1, 78.233))) * 43758.5453);\n}\nvec3 l(vec3 a, float b) {\n\treturn abs(a - b);\n}\nvoid main() {\n\tvec3 purple = vec3(0.486, 0.149, 1.) * 0.6;\n\tvec3 m = vec3(.97647);\n\tvec2 nVuv = aspectCover(vUv, uImageSize, uMeshSize);\n\tvec4 tex = texture2D(uTexture, vUv);\n\tfloat tex2Avrg = ((tex.r + tex.g) + tex.b) / 3.0;\n\tnVuv.x -= 0.5;\n\tnVuv.y -= 0.5;\n\tnVuv *= (1.0 - ((((0.6 - tex2Avrg) * rand(vec2(nVuv.x + cos(nVuv.y), nVuv.y + sin(nVuv.x)))) * 1.0) * (1.0 - uOpacity)));\n\tnVuv.x += 0.5;\n\tnVuv.y += 0.5;\n\tvec4 tex1 = texture2D(uTexture, nVuv);\n\tvec2 texLimit = abs(floor(nVuv));\n\tvec4 texCropped = mix(vec4(1, 1, 1, 0.), tex1, step(max(texLimit.x, texLimit.y), 0.));\n\tfloat texAvrg = ((texCropped.r + texCropped.g) + texCropped.b) / 3.0;\n\tvec3 color = texCropped.rgb;\n\tcolor = vec3(l(color, 1. - uOpacity));\n\tgl_FragColor = vec4(color, (tex1.a * uOpacity) * uAlpha);\n}\n";
      },
      "./styles/app.css": () => { }
    },
    (e) => {
      var t = (t) => e((e.s = t));
      e.O(0, [259, 655], () => (t("./scripts/app.js"), t("./styles/app.css"))),
        e.O();
    },
  ]);
}  







